
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { HighchartsChartModule } from 'highcharts-angular';
import Highcharts from 'highcharts/es-modules/masters/highcharts.src.js';
import 'highcharts/es-modules/masters/modules/wordcloud.src';
import { NoWidgetDataComponent } from '../../../../components/my-brand-screen/no-widget-data/no-widget-data.component';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-word-cloud-card',
  imports: [HighchartsChartModule, CommonModule, NoWidgetDataComponent, AssetVersionPipe],
  templateUrl: './word-cloud-card.component.html',
  styleUrl: './word-cloud-card.component.scss',
})
export class WordCloudCardComponent implements OnChanges {
  @Input() brandKey?: string;
  @Input() brandName?: string;
  @Input() brandLogo?: string;
  @Input() brandColor?: string;
  @Input() data?: { name: string; weight: number }[];
  @Input() chartWidth: number = 342;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  ngOnChanges(): void {
    if (!this.data) {
      return;
    }
    this.chartOptions = {
      chart: {
        type: 'wordcloud',
        height: 240,
        width: this.chartWidth,
        animation: false,
      },
      title: {
        text: undefined
      },
      tooltip: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      series: [{
        type: 'wordcloud',
        data: this.getData(),
        name: 'Occurrences',
        colorByPoint: true,
        animation: false,
        rotation: {
          orientations: 1
        },
      }],
      plotOptions: {
        wordcloud: {
          minFontSize: 8,
          maxFontSize: 20,
          style: {
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 'normal',
          },
          states: {
            hover: {
              enabled: false
            }
          },
        }
      },
    };
  }

  protected getData(): { name: string; weight: number, color: string }[] | undefined {
    const secondaryMaxWeight = [...new Set(this.data?.map(item => item.weight) || [])]
      .sort((a, b) => b - a)[1] ?? 0;
    return this.data?.map(item => ({
      name: item.name,
      weight: item.weight,
      color: (this.brandColor && item.weight >= secondaryMaxWeight) ? this.brandColor : '#CDD1D7'
    }));
  }

  protected onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = new AssetVersionPipe().transform('images/no-logo.png');
  }
}
